import litigantMenuConstants from "../constants/litigantMenuConstants";
import litigantMenuService from "../services/litigantMenuService";
import alertActions from "./alertActions";

const getLitigantMenuOptions = id => {
  //console.log("Action triggered");
  const request = token => {
    //console.log("Request triggered");
    return { type: litigantMenuConstants.REQUEST_MENU_OPTIONS, id };
  };
  const success = payload => {
    //console.log("Success triggered");
    //console.log(payload);
    return {
      type: litigantMenuConstants.REQUEST_MENU_OPTIONS_SUCCESS,
      payload
    };
  };
  const failure = error => {
    //console.log("Failure triggered");
    return { type: litigantMenuConstants.REQUEST_MENU_OPTIONS_FAILURE, error };
  };

  return dispatch => {
    dispatch(request(id));

    litigantMenuService.getLitigantMenuOptions(id).then(
      litigantMenu => {
        dispatch(success(litigantMenu));
        //history.push("/user");
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
};

const litigantMenuActions = {
  getLitigantMenuOptions
};

export default litigantMenuActions;
